module.exports = __webpack_public_path__ + "static/media/The Terrace Alcoves 4.edfaa280.jpg";